import React, {useEffect, useState} from 'react';
import {useSelector, useDispatch} from 'react-redux';
import {Layout, PageHeader, Spinner} from '../components';
import {Box, CircularProgress, Pagination, Typography} from '@mui/material';
import {useLocation, useNavigate} from 'react-router-dom';
import PdfsReportTable from '../components/CustomTables/PdfReportsTable';
import {
  getPdfReportsByName,
  getPdfPayloadById,
  sendPdfByMail,
} from '../actions/pdfReportsActions';
import generatePDFBlob from './Services/PDF/util/generatePdfBlob';
import moment from 'moment';
import {getPdfPayloadByIdApi} from '../api/pdfReports.service';

const EscalatorReports = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const {
    escalatorReports,
    escalatorsReportsPage,
    escalatorsReportsTotalPages,
    pdfLoading,
    pdfPayload,
    emailSending,
  } = useSelector(s => s.pdfReports);
  const {user} = useSelector(s => s.user);

  const [isLoading, setIsLoading] = useState(false);
  const [pdfBlob, setPdfBlob] = useState(null);

  const {elevatorId, elevatorDetails} = location?.state || {};

  const getSerialNumber = () => {
    const currentSerial = localStorage.getItem('serialNo') || '001';
    const currentMonth = moment().format('MM');
    const currentYear = moment().format('YY');
    const fullSerial = `${currentSerial}${currentMonth}${currentYear}`;

    return fullSerial;
  };

  const onPageChange = (e, value) => {
    dispatch(
      getPdfReportsByName(elevatorDetails?.name, {
        page: value,
        templateType: 'ESCALATOR',
      }),
    );
  };

  useEffect(() => {
    dispatch(
      getPdfReportsByName(elevatorDetails?.name, {templateType: 'ESCALATOR'}),
    );
  }, []);

  const onRowClick = async obj => {
    setIsLoading(true);
    const response = await getPdfPayloadByIdApi(obj.id);
    const rawPayload = response.data?.payload;
    setIsLoading(false);
    if (rawPayload) {
      const payload = {ordinalNr: getSerialNumber(), ...JSON.parse(rawPayload)};
      navigate(`/escalator_services_pdf`, {state: payload});
    } else {
      alert('PDF payload is not available yet.');
    }
  };

  const [signatureUrl, setSignatureUrl] = useState(null);
  useEffect(() => {
    const storedSignatureUrl = localStorage.getItem('signatureUrl');
    if (storedSignatureUrl) {
      setSignatureUrl(storedSignatureUrl);
    }
  }, []);

  const handleSendEmail = async obj => {
    const payload = {ordinalNr: getSerialNumber(), ...JSON.parse(obj.payload)};
    const blob = await generatePDFBlob(payload, signatureUrl);
    setPdfBlob(blob);
    if (!pdfBlob) {
      alert('PDF is not generated yet.');
      return;
    }
    const formData = new FormData();
    formData.append('reportId', getSerialNumber());
    formData.append('email', user?.email);
    formData.append('attachment', pdfBlob, 'elevator_service_report.pdf');

    // Dispatch action with formData as payload
    dispatch(sendPdfByMail(formData));
  };

  if (emailSending) {
    return (
      <div>
        <h3>Sending email .....</h3>
        <Spinner />;
      </div>
    );
  }

  if (isLoading) {
    return (
      <Layout>
        <Box
          mt="1rem"
          display="flex"
          flexDirection="column"
          gap={6}
          alignItems="center"
          alignSelf="center"
          justifyContent="center">
          <Typography variant="h4">Loading report...</Typography>
          <CircularProgress />
        </Box>
      </Layout>
    );
  }
  return (
    <Layout>
      <PageHeader title="Escalator Reports" />

      {/* Show loading spinner if the data is still loading */}
      {pdfLoading ? (
        <Box mt="1rem" display="flex" justifyContent="center">
          <CircularProgress />
        </Box>
      ) : escalatorReports?.length === 0 ? (
        <Box mt="1rem" display="flex" justifyContent="center">
          <Typography variant="h6">
            No reports available for this escalator.
          </Typography>
        </Box>
      ) : (
        <PdfsReportTable
          list={escalatorReports}
          loading={pdfLoading}
          onRowClick={onRowClick}
          handleSendEmail={handleSendEmail}
        />
      )}

      {escalatorsReportsTotalPages > 1 && (
        <Box mt="1rem" display="flex" justifyContent="center">
          <Pagination
            count={escalatorsReportsTotalPages}
            page={escalatorsReportsPage}
            onChange={onPageChange}
          />
        </Box>
      )}
    </Layout>
  );
};

export default EscalatorReports;
